import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const BillingContext = createContext(null);

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);
  const [paywall, setPaywall] = useState(null); // { action, credits_needed, credits_balance, message }

  const refresh = useCallback(async () => {
    if (!user) {
      setBilling(null);
      return;
    }
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
    } catch {
      setBilling(null);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Global 402 interceptor — surface as paywall modal
  useEffect(() => {
    const id = api.interceptors.response.use(
      (r) => r,
      (err) => {
        if (err.response?.status === 402 && err.response.data?.detail?.error === "insufficient_credits") {
          setPaywall(err.response.data.detail);
        }
        return Promise.reject(err);
      }
    );
    return () => api.interceptors.response.eject(id);
  }, []);

  return (
    <BillingContext.Provider value={{ billing, refresh, paywall, setPaywall }}>
      {children}
    </BillingContext.Provider>
  );
}

export const useBilling = () => useContext(BillingContext);
